import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectsDirectoryManageRootRedirectRoute: InvariantJiraRoute = {
	name: 'projects-directory-manage-root-redirect',
	path: '/jira/settings/projects',
	exact: true,
};
